// environment.ts

let apiBaseUrl: string;

const appEnv = process.env.NEXT_PUBLIC_APP_ENV;

// Always use FastAPI backend on localhost:8000 for local development
if (appEnv === "production") {
  apiBaseUrl =
    "https://api.backend.prod.serviceendpoints.co.za";
} else if (appEnv === "staging") {
  apiBaseUrl =
    "https://api.staging.serviceendpoints.co.za";
} else {
  // For local/dev or any other environment, use FastAPI backend on port 8000
  // Read from env var if available, otherwise default to port 8000
  const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL || "http://localhost:8000";
  apiBaseUrl = backendUrl;
  console.log(`Using FastAPI backend at ${apiBaseUrl}`);
}

// Note: All service files should include /api/v1/ prefix in their endpoint paths
// e.g., `${API_BASE_URL}/api/v1/forms/...` or `${API_BASE_URL}/api/v1/flows/...`

export const API_BASE_URL = apiBaseUrl;
export const APP_KEY = "BJF292NV91JC899U32CM02930MCDS12";
export const APP_ID = "mvia-inspector-admin";
export const GOOGLE_API_KEY = "AIzaSyBRn6IajqjIRA4Wb-xweuDVYu6QggOYOGA";
